import { z } from 'zod';
import { idSchema } from './common.js';
import { paginationMetaSchema, paginationQuerySchema } from './pagination.js';
import { documentTypeSchema } from './enums.js';
import { LEGACY_DOCUMENT_KINDS, legacyAmountSchema, legacyDocumentInputSchema, legacyHashSchema, legacySourceIdentitySchema, } from './legacy-document.js';
// Navigation categories never change the immutable source kind or its posting semantics.
export const LEGACY_DOCUMENT_CATEGORIES = {
    QUOTE: ['OFFER'],
    ORDER: ['ORDER'],
    DELIVERY_NOTE: ['DELIVERY'],
    INVOICE: ['INVOICE', 'CORRECTION_INVOICE', 'INVOICE_UNCLASSIFIED'],
    CANCELLATION: ['CANCELLATION'],
    CREDIT_NOTE: ['CREDIT_NOTE'],
    PURCHASE_ORDER: ['PURCHASE_ORDER'],
};
const calendarDate = z.string().date();
export const legacyDocumentQuerySchema = paginationQuerySchema
    .omit({ sort: true })
    .extend({
    sort: z
        .enum(['documentDate:asc', 'documentDate:desc', 'number:asc', 'number:desc'])
        .default('documentDate:desc'),
    kind: z.enum(LEGACY_DOCUMENT_KINDS).optional(),
    sourceSystem: z.enum(['LEXWARE', 'ORGAMAX']).optional(),
    sourceTenant: legacySourceIdentitySchema.innerType().shape.tenant.optional(),
    category: z
        .preprocess((value) => (typeof value === 'string' ? value.split(',') : value), z
        .array(z.enum(['ALL', ...documentTypeSchema.options]))
        .min(1)
        .max(documentTypeSchema.options.length))
        .optional(),
    dateFrom: calendarDate.optional(),
    dateTo: calendarDate.optional(),
    partnerId: idSchema.optional(),
    productId: idSchema.optional(),
})
    .strict()
    .refine((value) => !value.dateFrom || !value.dateTo || value.dateFrom <= value.dateTo, {
    path: ['dateTo'],
    message: 'The end date must not precede the start date.',
});
export const legacyDocumentSummarySchema = z
    .object({
    id: idSchema,
    origin: z.literal('IMPORTED_HISTORY'),
    source: legacySourceIdentitySchema,
    kind: z.enum(LEGACY_DOCUMENT_KINDS),
    number: z.string().nullable(),
    documentDate: z.string().nullable(),
    currency: z.string(),
    net: legacyAmountSchema.nullable(),
    tax: legacyAmountSchema.nullable(),
    gross: legacyAmountSchema.nullable(),
    partnerId: idSchema.nullable(),
    partnerNames: z.array(z.string()),
    partnerNumber: legacyDocumentInputSchema.innerType().shape.partner.shape.sourceKey.optional(),
    status: legacyDocumentInputSchema.innerType().shape.status,
    itemCount: z.number().int().nonnegative(),
})
    .strict();
export const legacyDocumentListSchema = z
    .object({ data: z.array(legacyDocumentSummarySchema), meta: paginationMetaSchema })
    .strict();
export const legacyDocumentArtifactSchema = z
    .object({
    id: idSchema,
    sha256: legacyHashSchema,
    bytes: z.number().int().nonnegative(),
    originalName: z.string(),
    role: z.enum(['ORIGINAL', 'SOURCE_ATTACHMENT']),
})
    .strict();
export const legacyDocumentDetailSchema = z
    .object({
    id: idSchema,
    origin: z.literal('IMPORTED_HISTORY'),
    partnerId: idSchema.nullable(),
    snapshot: legacyDocumentInputSchema,
    restrictedFields: z.boolean(),
    restrictedPayments: z.boolean(),
    relations: z.array(z
        .object({
        id: idSchema,
        kind: z.string(),
        direction: z.enum(['FROM', 'TO']),
        document: legacyDocumentSummarySchema,
    })
        .strict()),
    artifacts: z.array(legacyDocumentArtifactSchema),
})
    .strict();
//# sourceMappingURL=legacy-document-read.js.map